<template>
  <div class="about">
    <h1>Logging in...</h1>
  </div>
</template>
<script>
import Config from '@/config'
import Utils from '@/utils'
import { AppState } from '@/state'

export default {
  name: 'login',
  mounted () {
    const params = {}
    params['rz-app-key'] = Config.RZAppKey
    params.callback_url = window.location.href.replace('/login', '/login-response')
    console.log('Redirecting to', Utils.buildURL(Config.LoginPath, params))
    window.location.href = Utils.buildURL(Config.LoginPath, params)
  }
}
</script>
